import router from '../router';
const state = {
    selectedCompany : null,
    companies: [],
    currentCompany: {},
    showExpiryDate: false

};

const getters = {
	
};

const mutations = {
	setSelectedCompany(state, selectedCompany){
        state.selectedCompany = selectedCompany;
        router.go('/')
        console.log('New Selected Company: ' + state.selectedCompany)
    },
    setCompanies(state, companies){
        state.companies = companies;
    },
    setCurrentCompany(state, currentCompany){
        if (currentCompany.is_free){
            state.showExpiryDialog = true;
        }
        state.currentCompany = currentCompany;
    }
};

const actions = {
	setSelectedCompany({commit}, selectedCompany){
        commit('setSelectedCompany', selectedCompany);
    },
    setCompanies({commit}, companies) {
        commit('setCompanies', companies);
    },
    setCurrentCompany({commit}, currentCompany) {
        commit('setCurrentCompany', currentCompany);
    }
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};